import React, { useEffect, useRef } from 'react';

import GlobalStyles from '@styles/GlobalStyles';
import Navigation from '@core/Navigation';
import CookieBanner from '@core/CookieBanner';
import { isBrowser } from '@utils';

const Layout = ({ children, location }) => {
  const hasLoaded = useRef(null);

  useEffect(() => {
    if (!hasLoaded.current) {
      hasLoaded.current = true;
    }
  }, []);

  return (
    <>
      <GlobalStyles />
      <Navigation
        introAnimation={
          (location && location.state && location.state.introAnimation) ||
          (location.pathname === '/' && !hasLoaded.current)
        }
      />
      {children}
      {isBrowser && <CookieBanner />}
    </>
  );
};

export default Layout;
